// test166
(166 && 0);
